import React from "react";

import { useField, useFormikContext } from "formik";
import PropTypes from "prop-types";

import { InputLabel, TextField, withStyles } from "@material-ui/core";
import OutlinedInput from "@material-ui/core/OutlinedInput";

export const FormLabel = withStyles({
  root: {
    fontSize: "14px",
    fontFamily: `'Roboto', sans-serif`,
    marginLeft: "5px",
    marginBottom: "16px",
    fontWeight: 400,
    color: "#002856",
  },
})(InputLabel);

function BootstrapInput(props) {
  const { classes, ...other } = props;
  return (
    <OutlinedInput
      classes={{
        root: classes.bootstrapRoot,
        input: classes.bootstrapInput,
      }}
      {...other}
    />
  );
}

BootstrapInput.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default function FormTextInput({
  required = false,
  name,
  label,
  fullWidth,
  commonProps = {},
  onBlur,
  ...rest
}) {
  const id = `${name}-input`;
  const [_field, meta] = useField(name);
  const { onBlur: _formikOnBlur, ...field } = _field;
  const formikContext = useFormikContext();
  const { isSubmitting: disabled } = formikContext;
  const errorMessage = meta.error && meta.touched ? meta.error : "";
  const handleBlur = (e) => {
    _formikOnBlur(e);
    onBlur && onBlur(e);
  };

  return (
    <div
      className={
        "d-flex flex-column input-margin appbar-div-investor-flow dual-margin-investor-flow"
      }
      style={fullWidth ? { gridColumn: "span 2" } : {}}
    >
      <div className="nps-form-label" htmlFor={id}>
        {label}
        {required && "*"}
      </div>
      <TextField
        id={id}
        label=""
        error={!!errorMessage}
        disabled={disabled}
        variant="outlined"
        size="small"
        {...field}
        onBlur={handleBlur}
        inputProps={
          commonProps.capitalize && {
            style: { textTransform: "uppercase" },
          }
        }
        {...rest}
      />
      <div className="nps-error-message">{errorMessage}</div>
    </div>
  );
}

FormTextInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  commonProps: PropTypes.object,
};
